import { store } from './index'
export const useAppStore = defineStore(
  'APP_APP_CONFIG',
  () => {
    const theme = ref('#165DFF')
    const model = ref<'light' | 'dark'>('light')
    return {
      theme,
      model
    }
  },
  {
    persist: {
      paths: ['theme']
    }
  }
)

export function useAppStoreWithOut() {
  return useAppStore(store)
}
